<template>
    <div class="container">
        <div class="main">
            <div class="context">
                <el-row style="padding: 20px;">
                    <el-col :span="8">
                        <div style="background-color:#fff ;" class="headimage">
                            <!-- <img src="../assets/platformlogin.jpg" alt="" class="headimage"> -->
                        </div>
                    </el-col>

                    <el-col :span="16" id="applicationsyle">
                        <div class="app">
                            <div class="app_title">
                                <!-- 智慧校园信息服务平台应用中心 -->
                                {{ config.schooName }}智慧校园信息服务平台应用中心
                            </div>

                            <div style="background-color:#fff !important ;">
                                <div class="leftAPP_1 bgBlueList" :style="{
                                    backgroundColor: '#fff',
                                    display:
                                        currentCategoryIndex == categoryIndex ? 'block' : 'none',
                                }" v-for="(category, categoryIndex) in clients" :key="category.ClientCategoryId">
                                    <dl v-for="client in category.Clients" :key="client.ClientId">
                                        <dt style="background: #fff !important;">
                                            <a :href="client.ClientUri" @click="onClientVisited(client)" target="_blank"
                                                style="background: #fff !important;">
                                                <img :src="client.LogoUri" class="client-logo" />
                                            </a>
                                        </dt>
                                        <dd style="background: #fff !important;">
                                            <a :title="client.ClientName" :href="client.ClientUri" target="_blank"
                                                style="background: #fff !important;">{{
                                                    client.ClientName }}</a>
                                        </dd>
                                    </dl>
                                    <div class="clear"></div>
                                </div>
                            </div>

                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- <el-footer style="height:35px:">
            <div class="footerMessageM">
                <span style="color: rgb(102, 102, 102); text-align: center; margin-right:50px ;">版权所有@湖南师范大学附属中学</span>
                <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">湘ICP备05014582号</a>
            </div>
        </el-footer> -->
    </div>
</template>

<script>
import "./home.scss";
import { GetClients, VisitedClient } from "../api/identity_server/client";
import Header from "./common/header";
import Footer from "./common/footer";
import Banner from "./common/banner";
export default {
    name: "HelloWorld",
    components: { Header, Banner, Footer },
    data() {
        return {
            articles: [],
            clients: [],
            currentCategoryIndex: 0,
            dataStatistics: {
                SchoolCount: 0,
                TeacherCount: 0,
                ParentCount: 0,
                StudentCount: 0,
            },
            realtimeStatistics: {
                ClientCount: 0,
                VisitedCount: 0,
            },
            config: window.config
        };
    },
    methods: {
        onClientVisited: function (client) {
            VisitedClient(client.ClientId);
        },
        getClients: function () {
            GetClients().then((result) => {
                if (result.success) {
                    this.clients = result.data || [];
                }
            });
        },

    },
    mounted() {
        var that = this;
        this.getClients();
    },
};
</script>
<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;

}

.container {
    // height: 800px;
    background-color: #f0f2f5 !important;
    /* padding: 1px; */
}

.main {
    width: 60%;
    // 三行五列用以下
    margin: 180px auto;
    // 四行五列用以下
    // margin: 100px auto;
}
.headimage {
    background-image: url(../assets/platformlogin.jpg);
    background-size: contain;
    // 三行五列用以下
    background-repeat: repeat-y;
    height: 550px;
    // 四行五列用以下
    // background-repeat: repeat-y;
    // height: 700px;
}
.context {
    background-color: #f0f2f5 !important;
}

.app {
    background-color: #fff !important;
}

.app_title {
    margin: 20px 20px 20px 55px;
    font-size: 18px;
    background: #fff;
}

#applicationsyle {
    background: #fff !important;
}

.leftAPP_1 bgBlueList {
    background-color: #fff !important;
}

.el-row {
    background: #fff !important;
}

.el-col {
    background: #fff !important;
}

.footerMessageM {
    text-align: center;
}

.leftAPP_1 dl {
    background: #fff !important;
}

@media screen and (max-width: 700px) {
    .container {
        height: 0px !important;
        background-color: #f0f2f5 !important;
    }

    .main {
        width: 100%;
        margin: 0 auto;
        background-color: #fff !important;
    }

    .context {
        background-color: #fff !important;
        padding: 0px;
    }

    .headimage {
        background-image: url(../assets/platformlogin_700.jpg);
        background-repeat: no-repeat;
        background-size: cover;
        height: 190px;
        width: 300%;
    }

    .app_title {
        margin: 20px 20px 20px 20px;
        font-size: 18px;
        background: #fff;
        text-align: center;
    }

    #applicationsyle {
        background: #fff !important;
        padding: 0 0 50px 0;
    }

    .leftAPP_1 dl {
        float: left;
        width: 60px;
        text-align: center;
        margin: 24px 0 0 55px;
        background: #fff !important;
    }

    .leftAPP_1 dl dd {
        font-size: 14px;
        padding: 10px 0 0;
        white-space: nowrap;
        overflow: inherit;
        text-overflow: ellipsis;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue